import SampleBotActions from '../actions/SampleBotCRUDActions';
import Actions from '../actions/actions';
import { retrievedAll, setBusy } from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [],
};

const sampleBots = (state = initialState, action) => {
  switch (action.type) {
    case SampleBotActions.busyAction: return setBusy(state);
    case SampleBotActions.retrievedAllAction: return retrievedAll(state, action);
    case Actions.RESET: return initialState;
    case Actions.UNBUSY: { return { ...state, busy: false } }
    default: return state;
  }
};

export default sampleBots;
